import { Link } from "react-router-dom";
import { LI, UL } from "../../../../../../AbstractElements";
import { Href } from "../../../../../../Constants/Constants";
import { FilterProductData } from "../../../../../../Data/Applications/ECommerce/ECommerce";
import { useAppDispatch } from "../../../../../../ReduxToolkit/Hooks";
import { setColView } from "../../../../../../ReduxToolkit/Reducers/ECommerce/FilterSlice";

const GridOptions = () => {
  const dispatch = useAppDispatch();
  return (
    <div className="grid-options d-inline-block">
      <UL className="simple-list flex-row">
        {FilterProductData.map((data, index) => (
          <LI key={index}>
            <Link className={`product-${data.id}-layout-view`} to={Href} onClick={() => dispatch(setColView(data.colClass))}>
              {data.filterData.map((item, number) => (
                <span key={number} className={`line-grid line-grid-${item} bg-primary`}></span>
              ))}
            </Link>
          </LI>
        ))}
      </UL>
    </div>
  );
};

export default GridOptions;
